type Config = {
  pixelId: string;
  enabled?: boolean;
};

declare global {
  interface Window {
    ttq: any;
    TiktokAnalyticsObject?: any;
  }
}

export default function TikTokPixel(config: Config): any {
  let isLoaded = false;

  return {
    name: 'tiktok-pixel',

    initialize: () => {
      if (!config.enabled || typeof window === 'undefined') return;

      if (!window.ttq) {
        (function (w, d, t) {
          w.TiktokAnalyticsObject = t;
          const ttq = (w[t] = w[t] || []);
          ttq.methods = [
            'page',
            'track',
            'identify',
            'instances',
            'debug',
            'on',
            'off',
            'once',
            'ready',
            'alias',
            'group',
            'enableCookie',
            'disableCookie',
            'holdConsent',
            'revokeConsent',
            'grantConsent',
          ];
          ttq.setAndDefer = function (t: any, e: any) {
            t[e] = function (...args: any[]) {
              t.push([e, ...args]);
            };
          };
          for (let i = 0; i < ttq.methods.length; i++) {
            ttq.setAndDefer(ttq, ttq.methods[i]);
          }
          ttq.instance = function (t: any) {
            const e = ttq._i[t] || [];
            for (let i = 0; i < ttq.methods.length; i++) {
              ttq.setAndDefer(e, ttq.methods[i]);
            }
            return e;
          };
          ttq.load = function (e: string, n: any) {
            const r = 'https://analytics.tiktok.com/i18n/pixel/events.js';
            const o = n && n.partner;
            ttq._i = ttq._i || {};
            ttq._i[e] = [];
            ttq._i[e]._u = r;
            ttq._t = ttq._t || {};
            ttq._t[e] = +new Date();
            ttq._o = ttq._o || {};
            ttq._o[e] = n || {};
            const script = d.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = r + '?sdkid=' + e + '&lib=' + t;
            const firstScript = d.getElementsByTagName('script')[0];
            firstScript.parentNode?.insertBefore(script, firstScript);
          };

          ttq.load(config.pixelId);
          ttq.page();
        })(window, document, 'ttq');

        isLoaded = true;
      }
    },

    page: () => {
      if (typeof window !== 'undefined' && window.ttq) {
        window.ttq.page();
      }
    },

    track: ({ payload }: any) => {
      if (typeof window !== 'undefined' && window.ttq) {
        window.ttq.track(payload.event, payload.properties || {});
      }
    },

    loaded: () => isLoaded,
  };
}
